
import React, { memo } from "react";
import { MoviesByDirector } from "@/types/movie";
import DirectorSectionList from "./DirectorSectionList";
import EmptyMovieList from "./EmptyMovieList";

interface MovieListContainerProps {
  moviesByDirector: MoviesByDirector;
  emptyMessage: string | React.ReactNode;
  currentTab: string;
  viewMode: "grid" | "list";
  isAuthenticated?: boolean;
  onOpenMovieDetails?: (tmdbId: number) => void;
}

// Using memo to optimize rendering
const MovieListContainer = memo<MovieListContainerProps>(({ 
  moviesByDirector, 
  emptyMessage, 
  currentTab,
  viewMode,
  isAuthenticated = false,
  onOpenMovieDetails
}) => {
  // Get directors from moviesByDirector
  const directors = Object.keys(moviesByDirector).sort();
  
  // Display empty message if there are no directors
  if (directors.length === 0) {
    return <EmptyMovieList emptyMessage={emptyMessage} isAuthenticated={isAuthenticated} />;
  }
  
  return (
    <DirectorSectionList
      directors={directors}
      moviesByDirector={moviesByDirector}
      currentTab={currentTab}
      viewMode={viewMode}
      onOpenMovieDetails={onOpenMovieDetails}
    />
  );
});

MovieListContainer.displayName = "MovieListContainer";

export default MovieListContainer;
